<template>
	<div class="display-flex flex-row flex-align-center">
		<ProjectAvatars
			forceGet
			tooltipDirection="bottom"
			:key="selectedProject?.id"
			:projectId="selectedProject?.id"
			v-if="selectedProject?.id && !isPersonalProject"
		/>

		<div v-if="isPersonalProject" class="display-flex flex-row ml-4">
			<div class="project-info">Personal space</div>
			<div class="info-container">
				<ProjectMenuSectionInfo :isPersonal="isPersonalProject" />
			</div>
		</div>
		<ProjectMenuSettingsDropdown class="ml-2" v-if="showSetting" :project="selectedProject" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { ProjectPermissions } from '@ply-io/ply-front-shared-utilities';
import ProjectAvatars from '@/components/ProjectMenu/ProjectAvatars.vue';
import { selectedProjectId } from '@/store/modules/selectedProject/getters';
import { getProject, projectHasPermission } from '@/store/modules/projects/getters';
import ProjectMenuSectionInfo from '@/components/ProjectMenu/ProjectMenuSectionInfo.vue';
import ProjectMenuSettingsDropdown from '@/components/ProjectMenu/ProjectMenuSettingsDropdown.vue';
import ProjectsService from '@/utils/projects-service';
export default {
	name: 'TopBarProjectDetails',
	props: {},
	components: {
		ProjectAvatars,
		ProjectMenuSectionInfo,
		ProjectMenuSettingsDropdown,
	},
	computed: {
		...mapGetters([getProject.fullPath, selectedProjectId.fullPath, projectHasPermission.fullPath]),
		projectIdentifier() {
			const identifier = this[selectedProjectId.fullPath];
			return isNaN(identifier) ? identifier.toLowerCase() : identifier;
		},
		showSetting() {
			return Boolean(this.selectedProject?.id) && this.hasPermissionToSeeSettings;
		},
		hasPermissionToSeeSettings() {
			return this[projectHasPermission.fullPath](this.selectedProject?.id, ProjectPermissions.ViewSettings);
		},
		selectedProject() {
			if (!this.projectIdentifier) {
				return null;
			}
			return this[getProject.fullPath](this.projectIdentifier);
		},
		isPersonalProject() {
			return ProjectsService.isPersonalProject(this.selectedProject);
		},
	},
	methods: {},
	data() {
		return {};
	},
	created() {},
};
</script>
<style scoped lang="scss">
.info-container {
	margin-top: -4px;
	margin-left: 1px;
}
.project-info {
	font-size: 12px;
	font-weight: 400;
	color: #b3b3b3;
}
</style>
